import authReducer from 'pages/LoginPage/slice/authSlice';
import global from 'reducers/global';
import position from 'pages/Position/reducers';
import requestWarrantyRepair from 'pages/RequestWarrantyRepair/reducers';
import coupon from 'pages/Coupon/reducers';
import componentDivide from 'pages/ComponentDivide/reducers'
import orders from 'pages/Orders/reducers';
import receiveSlip from "pages/ReceiveSlip/reducers"
import paymentSlip from "pages/PaymentSlip/reducers"
import prices from 'pages/Prices/reducers'
import timeKeeping from 'pages/TimeKeeping/reducers';
import { mailbox } from 'pages/Mail/reducers/index';
import stocksTakeRequest from 'pages/StocksTakeRequest/reducers';
import { announce } from 'pages/Announce/reducers/index';

export default {
  global: global,
  coupon: coupon,
  auth: authReducer,
  position: position,
  requestWarrantyRepair: requestWarrantyRepair,
  componentDivide: componentDivide,
  orders: orders,
  receiveSlip: receiveSlip,
  paymentSlip: paymentSlip,
  prices: prices,
  timeKeeping: timeKeeping,
  mailbox: mailbox,
  stocksTakeRequest: stocksTakeRequest,
  announce: announce,
};
